export function imgBaseUrl() {
    const baseUrl = '';
    return baseUrl;
}
